// @flow
import React, {Fragment, PureComponent, type ComponentType} from 'react';
import {findDOMNode} from 'react-dom';
import BrandConsolidationBanner from '@homeaway/react-brand-consolidation';
import ReactResizeDetector from 'react-resize-detector';
import GDPRBanner from '../GDPRBanner/GDPRBanner';

import type {Size} from '../../actions/topBanners';
import type {State as AbacusState} from '../../reducers/abacus';
import type {SystemData} from '../../../server/utils/systemData';

import './withTopBanners.less';

export type Props = {
    onTopBannersSizeChanged: (Size) => any,
    abacus: AbacusState,
    siteName: string,
    locale: string,
    showConsolidationBanner: boolean,
    system: SystemData
};

export default function withTopBanners<OwnProps: {}>(
    WrappedComponent: ComponentType<$Supertype<OwnProps>>
): ComponentType<Props> {
    return class TopBanners extends PureComponent<Props> {
        componentDidMount() {
            const {isMobile, isTablet} = this.props.system;

            if (isMobile || isTablet) {
                this.loadAppBanner();
            }
        }

        getGDPRBannerVersion = () => {
            const {
                abacus: {ha_gdpr_banner: experiment}
            } = this.props;

            if (
                experiment &&
                experiment.bucket &&
                experiment.bucket.bucketConfig
            ) {
                const {
                    bucket: {bucketConfig}
                } = experiment;

                return bucketConfig;
            }

            return null;
        };

        onResize = (width, height) => {
            this.props.onTopBannersSizeChanged({
                height
            });
        };

        loadAppBanner() {
            return import(/* webpackChunkName: "branch.io" */ '@homeaway/branch.io').then(
                (branch) => {
                    // Initialize app banner
                    const appBanner = branch.default();

                    appBanner.addListener(
                        'didShowBanner',
                        this.didShowAppBanner
                    );
                }
            );
        }

        didShowAppBanner = () => {
            const node: any = findDOMNode(this);
            const appBannerRef: any = document.getElementById('branch-banner');

            if (appBannerRef) {
                node.insertBefore(appBannerRef, node.firstChild);
            }
        };

        render() {
            const {siteName, locale, showConsolidationBanner} = this.props;
            const gdprBannerVersion = this.getGDPRBannerVersion();

            return (
                <Fragment>
                    <div className="TopBanners">
                        {gdprBannerVersion && (
                            <GDPRBanner
                                locale={locale}
                                bannerVersion={gdprBannerVersion}
                            />
                        )}
                        {showConsolidationBanner && (
                            <BrandConsolidationBanner siteName={siteName} />
                        )}
                        <ReactResizeDetector
                            handleHeight
                            onResize={this.onResize}
                        />
                    </div>
                    <WrappedComponent {...this.props} />
                </Fragment>
            );
        }
    };
}
